 
// import { createTheme } from '@mui/material/styles'

// const theme = createTheme({
//   palette: {
//     mode: 'light',

//     /* ===============================
//        BRAND SYSTEM
//     =============================== */
//     primary: {
//       main: '#334155', // slate-700
//       light: '#475569', // slate-600
//       dark: '#1e293b', // slate-800
//       contrastText: '#ffffff'
//     }
//     ,

//     /* ===============================
//        NEUTRAL SCALE (ENTERPRISE CORE)
//     =============================== */
//     neutral: {
//       50: '#f8fafc',
//       100: '#f1f5f9',
//       200: '#e2e8f0',
//       300: '#cbd5f5',
//       400: '#94a3b8',
//       500: '#64748b',
//       600: '#475569',
//       700: '#334155',
//       800: '#1e293b',
//       900: '#0f172a'
//     },

//     /* ===============================
//        STATUS COLORS
//     =============================== */
//     success: {
//       main: '#10b981',
//       contrastText: '#ffffff'
//     },
//     warning: {
//       main: '#f59e0b',
//       contrastText: '#ffffff'
//     },
//     error: {
//       main: '#ef4444',
//       contrastText: '#ffffff'
//     },
//     info: {
//       main: '#6366f1',
//       contrastText: '#ffffff'
//     },

//     /* ===============================
//        TEXT SYSTEM
//     =============================== */
//     text: {
//       primary: '#0f172a',
//       secondary: '#475569',
//       disabled: '#94a3b8'
//     },

//     /* ===============================
//        BACKGROUND SYSTEM
//     =============================== */
//     background: {
//       default: '#f8fafc',
//       paper: '#ffffff',
//       subtle: '#f1f5f9'
//     },

//     divider: 'rgba(15,23,42,0.08)',

//     action: {
//       hover: 'rgba(79,70,229,0.05)',
//       selected: 'rgba(79,70,229,0.10)',
//       disabled: 'rgba(15,23,42,0.30)',
//       disabledBackground: 'rgba(15,23,42,0.08)'
//     },

//     /* ===============================
//        BUSINESS STATUS
//     =============================== */
//     status: {
//       approved: '#10b981',
//       pending: '#f59e0b',
//       rejected: '#ef4444',
//       draft: '#64748b'
//     },

//     /* ===============================
//        GRADIENTS (SUBTLE)
//     =============================== */
//     gradient: {
//       primary: 'linear-gradient(135deg,#4f46e5,#6366f1)',
//       success: 'linear-gradient(135deg,#10b981,#059669)',
//       surface: 'linear-gradient(180deg,#ffffff,#f8fafc)'
//     }
//   },

//   /* ===============================
//      TYPOGRAPHY SYSTEM
//   =============================== */
//   typography: {
//     fontFamily:
//       "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
//     fontSize: 13,

//     h1: { fontWeight: 700, letterSpacing: -0.8 },
//     h2: { fontWeight: 700, letterSpacing: -0.6 },
//     h3: { fontWeight: 600, letterSpacing: -0.4 },
//     h4: { fontWeight: 600 },
//     h5: { fontWeight: 600 },
//     h6: { fontWeight: 600 },

//     subtitle1: { fontWeight: 500 },
//     subtitle2: { fontWeight: 500 },

//     body1: { lineHeight: 1.6 },
//     body2: { lineHeight: 1.6 },

//     caption: {
//       fontSize: 11,
//       color: '#64748b'
//     },

//     overline: {
//       fontSize: 11,
//       fontWeight: 600,
//       letterSpacing: 1
//     }
//   },

//   /* ===============================
//      SHAPE
//   =============================== */
//   shape: {
//     borderRadius: 10
//   },

//   /* ===============================
//      SHADOW SYSTEM (ELEVATION LOGIC)
//   =============================== */
//   shadows: [
//     'none',
//     '0 1px 2px rgba(15,23,42,.04)',
//     '0 4px 10px rgba(15,23,42,.08)',
//     '0 8px 20px rgba(15,23,42,.10)',
//     '0 12px 32px rgba(15,23,42,.12)',
//     ...Array(20).fill('0 16px 40px rgba(15,23,42,.14)')
//   ],

//   /* ===============================
//      COMPONENT OVERRIDES
//   =============================== */
//   components: {
//     MuiButton: {
//       styleOverrides: {
//         root: {
//           textTransform: 'none',
//           fontWeight: 600,
//           borderRadius: 8
//         }
//       }
//     },

//     MuiPaper: {
//       styleOverrides: {
//         root: {
//           backgroundImage: 'none'
//         }
//       }
//     },

//     MuiTextField: {
//       defaultProps: {
//         size: 'medium'
//       }
//     },

//     MuiOutlinedInput: {
//       styleOverrides: {
//         root: {
//           backgroundColor: '#ffffff',
//           '& fieldset': {
//             borderColor: 'rgba(15,23,42,0.12)'
//           },
//           '&:hover fieldset': {
//             borderColor: '#4f46e5'
//           },
//           '&.Mui-focused fieldset': {
//             borderWidth: 1.5
//           }
//         }
//       }
//     },

//     MuiChip: {
//       styleOverrides: {
//         root: {
//           fontSize: 11,
//           fontWeight: 600,
//           borderRadius: 6
//         }
//       }
//     },

//     MuiTableCell: {
//       styleOverrides: {
//         root: {
//           borderBottom: '1px solid rgba(15,23,42,0.06)'
//         },
//         head: {
//           fontWeight: 600,
//           color: '#334155',
//           backgroundColor: '#f8fafc'
//         }
//       }
//     }
//   }
// })

// export default theme

 import { createTheme } from "@mui/material/styles";

/* ===============================
   SHARED TOKENS
================================ */
const baseTheme = {
  typography: {
    fontFamily:
      "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif",
    fontSize: 13,

    h1: { fontWeight: 700, letterSpacing: -0.8 },
    h2: { fontWeight: 700, letterSpacing: -0.6 },
    h3: { fontWeight: 600, letterSpacing: -0.4 },
    h4: { fontWeight: 600 },
    h5: { fontWeight: 600 },
    h6: { fontWeight: 600 },

    subtitle1: { fontWeight: 500 },
    subtitle2: { fontWeight: 500 },

    body1: { lineHeight: 1.6 },
    body2: { lineHeight: 1.6 },

    caption: {
      fontSize: 11
    },

    overline: {
      fontSize: 11,
      fontWeight: 600,
      letterSpacing: 1
    }
  },

  shape: {
    borderRadius: 10
  },

  shadows: [
    "none",
    "0 1px 2px rgba(0,0,0,.05)",
    "0 4px 10px rgba(0,0,0,.08)",
    "0 8px 20px rgba(0,0,0,.12)",
    "0 12px 32px rgba(0,0,0,.16)",
    ...Array(20).fill("0 16px 40px rgba(0,0,0,.20)")
  ],

  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          fontWeight: 600,
          borderRadius: 8
        }
      }
    },

    MuiPaper: {
      styleOverrides: {
        root: {
          backgroundImage: "none"
        }
      }
    },

    MuiTextField: {
      defaultProps: {
        size: "medium"
      }
    },

    MuiOutlinedInput: {
      styleOverrides: {
        root: ({ theme }) => ({
          backgroundColor: theme.palette.background.paper,
          "& fieldset": {
            borderColor: theme.palette.divider
          },
          "&:hover fieldset": {
            borderColor: theme.palette.primary.main
          },
          "&.Mui-focused fieldset": {
            borderWidth: 1.5
          }
        })
      }
    },

    MuiChip: {
      styleOverrides: {
        root: {
          fontSize: 11,
          fontWeight: 600,
          borderRadius: 6
        }
      }
    },

    MuiTableCell: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderBottom: `1px solid ${theme.palette.divider}`
        }),
        head: ({ theme }) => ({
          fontWeight: 600,
          color: theme.palette.text.primary,
          backgroundColor: theme.palette.background.subtle
        })
      }
    }
  }
};

/* ===============================
   LIGHT PALETTE
================================ */
const lightPalette = {
  mode: "light",

  primary: {
    main: "#334155",
    light: "#475569",
    dark: "#1e293b",
    contrastText: "#ffffff"
  },

  neutral: {
    50: "#f8fafc",
    100: "#f1f5f9",
    200: "#e2e8f0",
    300: "#cbd5f5",
    400: "#94a3b8",
    500: "#64748b",
    600: "#475569",
    700: "#334155",
    800: "#1e293b",
    900: "#0f172a"
  },

  background: {
    default: "#f8fafc",
    paper: "#ffffff",
    subtle: "#f1f5f9"
  },

  text: {
    primary: "#0f172a",
    secondary: "#475569",
    disabled: "#94a3b8"
  },

  divider: "rgba(15,23,42,0.08)"
};

/* ===============================
   DARK PALETTE
================================ */
const darkPalette = {
  mode: "dark",

  primary: {
    main: "#818cf8",
    light: "#a5b4fc",
    dark: "#6366f1",
    contrastText: "#0f172a"
  },

  neutral: {
    50: "#020617",
    100: "#020617",
    200: "#020617",
    300: "#1e293b",
    400: "#334155",
    500: "#475569",
    600: "#64748b",
    700: "#94a3b8",
    800: "#cbd5e1",
    900: "#e2e8f0"
  },

  background: {
    default: "#020617",
    paper: "#0f172a",
    subtle: "#020617"
  },

  text: {
    primary: "#e2e8f0",
    secondary: "#94a3b8",
    disabled: "#64748b"
  },

  divider: "rgba(148,163,184,0.16)"
};

/* ===============================
   THEME FACTORY
================================ */
export const getTheme = (mode = "light") =>
  createTheme({
    ...baseTheme,
    palette: {
      ...(mode === "light" ? lightPalette : darkPalette)
    }
  });


  export default getTheme;